module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image10.9a5df459.webp";